// eslint-disable-next-line import-x/no-named-as-default
import DS from 'ember-data';
import { type Registry as Services, service } from '@ember/service';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

type QueryResult = DS.PromiseArray<ModelRegistry['photo']>;

export default class PhotoRepositoryService extends BaseRepositoryService<
  ModelRegistry['photo']
> {
  @service session!: Services['session'];

  recordName = 'photo';
  implementMethods = ['query'];

  public async query(query: object, options?: object): Promise<QueryResult> {
    const { currentUser } = this.session;

    if (!currentUser?.hasAccessTo('calendar.properties.details.photos')) {
      return [] as unknown as QueryResult;
    }

    return super.query(query, options);
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/photo': PhotoRepositoryService;
  }
}
